import * as Actions from "../action/CommentLibraryAction";

const getInitialIsHTCompany = () =>
  Actions.normalizeIsHTCompany(sessionStorage.getItem("is_ht_company"));

const initialState = {
  showClModal: false,
  editorListner: false,
  isHTCompany: getInitialIsHTCompany(),
};

const CommentLibraryReducer = (state = initialState, action) => {
  switch (action?.type) {
    case Actions.SHOW_CL_MODAL: {
      return { ...state, showClModal: action.payload };
    }
    case Actions.GET_CL_LIST: {
      return { ...state, commentLibraryList: action.payload?.data, totalListCount: action.payload?.total };
    }
    case Actions.GET_CL_TAG_LIST: {
      return { ...state, clTagList: action.payload };
    }
    case Actions.GET_CL_SUMMARY_TAG_LIST: {
      return { ...state, clSummaryTagList: action.payload };
    }
    case Actions.GET_FULL_CL_LIST: {
      return { ...state, commentLibraryWholeList: action.payload?.data };
    }
    case Actions.ADD_NEW_NARRATIVE_COMMENT: {
      // The template editor can add to the narrative library before the library
      // list itself has ever been loaded; there is no page to trim and nothing to
      // reconcile, the list is fetched fresh the next time it is opened.
      if (!Array.isArray(state.commentLibraryList)) return state;
      // Drop the last row to keep the page size, but on a copy - popping the live
      // array mutated redux state, so anything reading commentLibraryList from an
      // older render silently saw a list missing its last row.
      const trimmedList = state.commentLibraryList.slice(0, -1);
      return { ...state, totalListCount: state.totalListCount + 1, commentLibraryList: [action.payload, ...trimmedList] };
    }
    case Actions.EDIT_NARRATIVE_COMMENT: {
      const newList = state.commentLibraryList
      const index = newList.findIndex((item) => item.id === action.payload.comment_id);
      newList[index] = { ...newList[index], ...action.payload, tags: action.payload?.tag_ids, summaries: action.payload?.summary_ids };
      return { ...state, commentLibraryList: newList };
    }
    case Actions.DELETE_NARRATIVE_COMMENT: {
      let deletedCommentList = state.commentLibraryList.filter((item) => item.id !== action.payload);
      return { ...state, commentLibraryList: deletedCommentList, totalListCount: state.totalListCount - 1 };
    }
    case Actions.UPDATE_DROPDOWN_VALUES: {
      return { ...state, [action.payload.key]: action.payload.value };
    }
    case Actions.SET_EDITOR_LISTNER: {
      return { ...state, editorListner: action.payload };
    }
    case Actions.DUPLICATE_COMMENT: {
      let newList = state.commentLibraryList;
      const index = newList.findIndex(item => item.id === action.payload?.id);
      if (index === -1) return newList;
      let updatedArray = [...newList];
      updatedArray.splice(index + 1, 0, action.payload.response);
      return { ...state, commentLibraryList: updatedArray }
    }
    case Actions.SET_IS_HT_COMPANY: {
      // Never clobber a resolved flag back to undefined. Consumers read undefined
      // as "not loaded yet" and skip their fetches, which left the comment library
      // empty and the Summaries/Ratings tab on the wrong variant.
      if (action.payload === undefined || action.payload === null) return state;
      return { ...state, isHTCompany: action.payload };
    }
    case Actions.GET_NN_TAG_LIST: {
      return { ...state, clTagList: action.payload };
    }
    default: {
      return state;
    }
  }
};

export default CommentLibraryReducer;
